export class RepresentanteLegalModel {

  public nomeRepresentante: string;

  public cpfRepresentante: string;
  public numCpfBaseRepresentante: number;
  public digCpfRepresentante: number;

  public dataNascimentoRepresentante;
  public codTipoResponsabilidadeRepresentante: string;
  public logradouroRepresentante: string;
  public cepRepresentante: string;
  public numeroEnderecoRepresentante: string;
  public complementoEnderecoRepresentante: string;
  public bairroRepresentante: string;
  public codigoMunicipioIBGERepresentante
  public dddTelefoneRepresentante: number;
  public telefoneRepresentante: number;
  public dddCelularRepresentante: number;
  public celularRepresentante: number;
  public emailPrincipalRepresentante: string;

  public nomeMaeRepresentante: string;  

}



// WEBPACK FOOTER //
// ./src/app/restrito/representanteLegal/shared/representante-legal.model.ts